
/**
 * Static data pools used by the "Recent Purchase" notification system.
 * Names lean toward a Spanish-speaking US audience; cities are US metros.
 */

export const BUYER_NAMES: string[] = [
  'María G.',
  'José L.',
  'Carmen R.',
  'Luis A.',
  'Ana S.',
  'Miguel T.',
  'Sofía M.',
  'Carlos D.',
  'Lucía P.',
  'Andrés V.',
  'Elena F.',
  'Ricardo N.',
  'Valeria C.',
  'Jorge H.',
  'Patricia B.',
  'Fernando Q.',
  'Isabel O.',
  'Diego E.',
  'Gabriela U.',
  'Roberto I.',
  'Jennifer K.',
  'Michael S.',
  'Ashley W.',
  'David M.',
  'Jessica L.',
  'Daniel R.',
  'Emily C.',
  'Christopher P.',
]

export const US_CITIES: string[] = [
  'Houston, TX',
  'Los Ángeles, CA',
  'Miami, FL',
  'Nueva York, NY',
  'Chicago, IL',
  'Phoenix, AZ',
  'San Antonio, TX',
  'Dallas, TX',
  'San Diego, CA',
  'Las Vegas, NV',
  'Orlando, FL',
  'Denver, CO',
  'Atlanta, GA',
  'El Paso, TX',
  'Austin, TX',
  'San José, CA',
  'Fresno, CA',
  'Charlotte, NC',
  'Albuquerque, NM',
  'Tampa, FL',
]

